import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Main from "../views/Main.vue";
import PromptPage from "../views/PromptPage.vue";
import Settings from "../views/Settings.vue";
import Legal from "../views/Legal.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Main",
        component: Main
    },
    {
        path: "/category/:category",
        name: "MainCategory",
        component: Main
    },
    {
        path: "/prompt/:prompt",
        name: "PromptPage",
        component: PromptPage
    },
    {
        path: "/settings",
        name: "Settings",
        component: Settings,
        meta: {
            title: 'GPTCraft - Settings'
        }
    },
    {
        path: "/legal",
        name: "Legal",
        component: Legal
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
